import wrapWithProvider from './src/components/FetchProvider';

import LogRocket from 'logrocket';
LogRocket.init('l6q8k1/imagine-top');

export const wrapRootElement = wrapWithProvider;
